module.exports = __webpack_public_path__ + "images/172_2048.jpg";